import { Node } from '@tiptap/core'

export const Placeholder = Node.create({
  name: 'placeholder',

  group: 'inline',
  content: 'inline*',

  inline: true,
  atom: true,
  selectable: false,

  addAttributes() {
    return {
      provider: {
        default: null,
      },
      item: {
        default: null,
      },
      label: {
        default: null,
      },
    }
  },

  renderHTML({ node }) {
    const isEmpty = this.options.ignoreValues || node.content.size === 0
    const highlightLabel = this.options.highlightEmpty && node.content.size === 0

    return [
      'span',
      {
        class: !isEmpty
          ? null
          : 'inline-block ' +
            (highlightLabel
              ? 'border-2 border-brand-500 bg-brand-100 text-brand-600'
              : 'bg-gray-200 text-gray-800') +
            ' px-2 rounded-full',
      },
      isEmpty ? node.attrs.label : 0,
    ]
  },
})
